import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "location_794b9d906dde636ece5098299a1387a5",
  "use": "location_794b9d906dde636ece5098299a1387a5-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"location_794b9d906dde636ece5098299a1387a5\">\n    <path fill-rule=\"nonzero\" d=\"M8 1C5.236 1 3 3.191 3 5.9 3 9.575 8 15 8 15s5-5.425 5-9.1C13 3.191 10.764 1 8 1zm0 6.65c-.986 0-1.786-.784-1.786-1.75S7.014 4.15 8 4.15s1.786.784 1.786 1.75S8.986 7.65 8 7.65z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id